import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import TextField, { OutlinedTextFieldProps } from '@material-ui/core/TextField';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      margin: `${theme.spacing(1)}px 0`
    },
    fieldContainer: {
      padding: '0 10%'
    },
    fieldContainerSpacing: {
      marginBottom: theme.spacing(2)
    },
    fieldContainerSpacingAlt: {
      marginBottom: theme.spacing(1.5)
    }
  };
});

type DivProps = React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement>;
interface ContainedFieldProps extends Omit<OutlinedTextFieldProps, 'variant'> {
  containerProps?: DivProps;
}
export interface InviteFormFragmentProps extends DivProps {
  firstNameProps?: ContainedFieldProps;
  lastNameProps?: ContainedFieldProps;
  emailProps?: ContainedFieldProps;
}

const ContainedField: React.FC<ContainedFieldProps> = ({ containerProps, ...rest }) => {
  return (
    <div {...containerProps}>
      <TextField fullWidth size={'small'} variant={'outlined'} {...rest} />
    </div>
  );
};

const InviteFormFragment: React.FC<InviteFormFragmentProps> = ({
  firstNameProps,
  lastNameProps,
  emailProps,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root} {...rest}>
      <ContainedField
        label={t('Invite a New Co-Educator')}
        placeholder={t('First Name')}
        containerProps={{ className: cx(classes.fieldContainer, classes.fieldContainerSpacing) }}
        {...firstNameProps}
      />
      <ContainedField
        placeholder={'Last Name'}
        containerProps={{ className: cx(classes.fieldContainer, classes.fieldContainerSpacing) }}
        {...lastNameProps}
      />
      <ContainedField
        placeholder={'Email Address'}
        containerProps={{ className: cx(classes.fieldContainer, classes.fieldContainerSpacingAlt) }}
        {...emailProps}
      />
    </div>
  );
};

export default InviteFormFragment;
